import request from '../../utils/request';

export function userRegister(params) {
  return request({
    url: '/users/register',
    method: 'post',
    data: params,
  });
}

export function userLogin(params) {
  return request({
    url: '/users/login',
    method: 'post',
    data: params,
  });
}

export function userLogout_() {
  return request({
    url: `/users/logout`,
    method: 'post',
  });
}

export function editUser(params) {
  return request({
    url: '/user-center/profiles',
    method: 'post',
    data: params,
  });
}

export function getPersonalInfo() {
  return request({
    url: '/user-center/profiles',
    method: 'get',
  });
}

export function UploadAvatar(params) {
  return request({
    url: '/user-center/avatar',
    method: 'post',
    data: params,
  });
}

export function delMyReport({ serial_number }) {
  return request({
    url: `/user-center/reports/${serial_number}`,
    method: 'delete',
  });
}

export function confirmReport(params) {
  return request({
    url: `/company-center/reports/confirm`,
    method: 'post',
    data: params,
  });
}

export function publishReport(params) {
  return request({
    url: `/company-center/reports/publish`,
    method: 'post',
    data: params,
  });
}

export function fixedReport(params) {
  return request({
    url: `/company-center/reports/fix`,
    method: 'post',
    data: params,
  });
}

export function getMfInfo() {
  return request({
    url: '/company-center/profiles',
    method: 'get',
  });
}

export function editMfInfo(params) {
  return request({
    url: '/company-center/profiles',
    method: 'post',
    data: params
  });
}

export function getMyTeam() {
  return request({
    url: '/user-center/teams',
    method: 'get',
  });
}

export function getMyTeamMember() {
  return request({
    url: '/user-center/teams/members',
    method: 'get',
  });
}

export function userResetPassword(params) {
  return request({
    url: '/users/password/reset',
    method: 'post',
    data: params,
  });
}

export function userForgetPasswordReset(params) {
  return request({
    url: '/users/password/reset_by_key',
    method: 'post',
    data: params,
  });
}

export function companySetLogo(params) {
  return request({
    url: '/company-center/logo',
    method: 'post',
    data: params,
  });
}

// company register

export function companyRegister(params) {
  return request({
    url: '/companies/register',
    method: 'post',
    data: params,
  });
}
// verification_code

export function getVerification_code(params) {
  return request({
    url: '/emails/companies/register',
    method: 'post',
    data: params,
  });
}

// 获取厂商分类
export function getCompanyCategories() {
  return request({
    url: '/companies/categories',
    method: 'get',
  });
}

export function login2FA(params) {
  return request({
    url: '/users/login-2fa',
    method: 'post',
    data: params,
  });
}

export function twoFA() {
  return request({
    url: '/users/auth/twoFA',
    method: 'get',
  });
}

export function bind2FA(params) {
  return request({
    url: '/users/auth/twoFA',
    method: 'post',
    data: params,
  });
}

export function unbind2FA() {
  return request({
    url: '/users/auth/twoFA/unbind',
    method: 'post',
  });
}

export function getLoginSignDate(address) {
  return request.post('users/login-signdata', {
    address
  })
}

export function walletLogin({signature, address}) {
  return request.post('/users/wallet-login', {
    signature,
    address
  })
}

export function emailExists({email, signal}) {
  console.log({email, signal}, '{email, signal}')
  return request.post('/users/email-exists', {
    email
  }, {
    signal
  })
}

export function getWalletVerificationCode(email) {
  return request.post('/emails/users/register', {
    email
  })
}

export function getWalletLoginVerificationCode(email) {
  return request.post('/emails/users/wallet-login', {
    email
  })
}
export function walletEmailBind(
  {
    address,
    email_bind_key,
    verification_key,
    email,
    verification_code
  }
) {
  return request.post('/users/bind-email', {
    address,
    email_bind_key,
    verification_key,
    email,
    verification_code
  })
}

export function getAdministratorList() {
  return request.get('/company-center/admins')
}

export function addAdministrator({username, email, confirmEmail}) {
  return request.post('/company-center/admins', {
    username,
    email,
    email_confirm: confirmEmail
  })
}

export function delAdministrator(userId) {
  return request.post(`/company-center/admins/${userId}`)
}


export function reInviteAdmin(userId) {
  return request.post(`/company-center/admins/reinvite/${userId}`)
}

export function checkInviteKey(key) {
  return request.post('/users/invite_key/check', {
    invite_key: key,
  })
}

export function adminSetPassword({key, password, confirmPassword}) {
  return request.post('users/company_admin_set_password', {
    user_invite_key: key,
      password,
    password_confirm: confirmPassword
  })
}
export function getVerificationCodeForEmailChange(email) {
  return request.post('/emails/users/change', {
    email
  })
}

export function changeEmail({email, password, verification_code, verification_key}) {
  return request.post('/user-center/profiles/email', {
    new_email: email,
    old_password: password,
    verification_code,
    verification_key
  })
}
